import React from 'react'
import { Table } from 'react-bootstrap'
import ToggleBar from '../../commoncomponents/toggleBar'
import { utcToReportDate } from '../../../utils/dateConvert'
import { downloadCSVFile } from '../../../api/apiClient'
import Location from '../../commoncomponents/location';
import ShowIButtonName from '../../commoncomponents/showIButtonName';
import { GetLocationAddress } from '../../../utils/mapapi';
import { formatTemperatureReading, getValidTemperature, temperatureReadingClass } from '../../../utils/temperature';

function GeooverlayExceptions(props) {
    let tempBEnabled = props.tempBEnabled;
    let tempAEnabled = props.tempAEnabled;
    let driverIDEnabled = props.driverIDEnabled;
    let assetId = props.assetId;
    let assetName = props.assetCustomerName;
    let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  
    const data = (
        <Table responsive striped>

            <thead>
                <tr className="nowwrapTH">
                    <th>ID</th>
                    <th>Started</th>
                    <th>Location</th>
                    <th>Duration</th>
                    <th>Type</th>
                    <th>Details</th>
                    <th>Ignition</th>
                    <th>Speed</th>
                    <th>Fridge</th>
                    {tempAEnabled && <th>Temp A</th>}
                    {tempBEnabled && <th>Temp B </th>}
                    {driverIDEnabled && <th>Driver ID</th>}
                </tr>
            </thead>
            <tbody>
                {props.reportDetail.map((item, index) => {

                    return (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{utcToReportDate(item.started)}</td>
                            <td>
                                <Location
                                    address={item.address}
                                    lat={item.latitude}
                                    lng={item.longitude}
                                />
                            </td>
                            <td>{item.duration}</td>
                            <td>{item.type}</td>
                            <td>{item.details}</td>
                            <td>{item.ignition ? "Engine On" : "Engine Off"}</td>
                            <td>{item.speed}</td>
                            <td>{item.fridge ? "On" : "Off"}</td>
                            {tempAEnabled && <td className={temperatureReadingClass(item.tempA)}>{formatTemperatureReading(item.tempA)}</td>}
                            {tempBEnabled && <td className={temperatureReadingClass(item.tempB)}>{formatTemperatureReading(item.tempB)}</td>}
                            {driverIDEnabled && <td>
                                    {item.driverID && 
                                <ShowIButtonName
                                    ibuttonId={item.ibuttonId}
                                    serialno={item.serialno}
                                    iButtonName={item.iButtonName}
                                />}
                                </td>}
                        </tr>
                    )
                })}

            </tbody>
        </Table>
    )
    const ReportDetailWithlocation = async () =>{
        const updatedDetails = await Promise.all(
          props.reportDetail.map(async (item) => {
            if (item.latitude && item.longitude && !item.address
            ) {
              try {
                const address = await GetLocationAddress(item.latitude, item.longitude);
                item.address = address;
              } catch (e) {
                item.address = `${item.latitude}, ${item.longitude}`;
              }
            } 
            return {
              ...item,
              tempA: getValidTemperature(item.tempA),
              tempB: getValidTemperature(item.tempB),
            };
          })
      );
      return updatedDetails;
      }

    const handleDownloadExcel = async () => {
        let reportData = await ReportDetailWithlocation();
        // alert("clicked")
        downloadCSVFile(reportData, "GeooverlayEvents", assetName, timeZone, assetId);
    }
    return (
        <ToggleBar caption="Geo-overlay Events" download={handleDownloadExcel} icon="fa-compass" color="#337ab7" content={data} />

    )
}

export default GeooverlayExceptions
